import React, { DOMAttributes } from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

export interface PaperProps extends DOMAttributes<HTMLDivElement> {
  className?: string;
  withShadow?: boolean;
}

const Paper: React.FC<PaperProps> = ({ className, withShadow = true, ...others }) => {
  const classes = useStyles();
  return <>{withShadow ? <div className={classes.hidden}></div> : null}<div className={clsx(classes.base, className)} {...others} /> </>;
};

const useStyles = createUseStyles({
  base: {
    backgroundColor: '#FFFFFF',
    // boxShadow: '0px 0px 10px #cac9c9',
    borderRadius: '10px',
    position: 'relative',
    overflow: 'hidden',
  },
  hidden: {

    top: "10px",
    left: "10px",
    width: "calc(100% - 20px)",
    height: "calc(100% - 10px)",
    position: "absolute",
    borderRadius: "20px",
    boxShadow: "0 0 20px 0 #52258333"
  }
});

export default Paper;
